/** One QC Sampling Request: its samples, and Cancel while none has been drawn. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { QcRequestDetailPage } from "@/features/quality/components/requests/qc-request-detail-page";

export const Route = createFileRoute("/_app/quality/requests/$requestId")({
  params: {
    parse: ({ requestId }) => {
      if (!/^\d+$/.test(requestId)) throw notFound();
      return { requestId };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { requestId } = Route.useParams();
  return <QcRequestDetailPage id={Number(requestId)} />;
}
